<script setup>
import { useQuasar } from 'quasar';
import { computed } from 'vue';

// Light steps to dark first, where the change always shows, then to the system setting, then back to light. Stepping
// from light to the system setting first changed nothing on a computer set to light, so the first click looked broken.
const THEME_MODES = Object.freeze([
    Object.freeze({ mode: false, icon: 'sym_r_light_mode', name: 'light', switchTo: 'light' }),
    Object.freeze({ mode: true, icon: 'sym_r_dark_mode', name: 'dark', switchTo: 'dark' }),
    Object.freeze({ mode: 'auto', icon: 'sym_r_auto_mode', name: 'matching your system', switchTo: 'match your system' })
]);

const $q = useQuasar();

const currentIndex = computed(() => Math.max(0, THEME_MODES.findIndex(theme => theme.mode === $q.dark.mode)));

const currentTheme = computed(() => THEME_MODES[currentIndex.value]);

const nextTheme = computed(() => THEME_MODES[(currentIndex.value + 1) % THEME_MODES.length]);

const buttonLabel = computed(() => `Theme: ${currentTheme.value.name}. Switch to ${nextTheme.value.switchTo}`);

const buttonPadding = computed(() => {
    if ($q.dark.mode === true) return '6px';
    return '7px 6px 5px 6px';
});

function toggleThemeMode() {
    $q.dark.set(nextTheme.value.mode);
}
</script>

<template>
    <div class="theme-mode-toggle-button">
        <q-no-ssr>
            <q-btn
                :aria-label="buttonLabel"
                :icon="currentTheme.icon"
                :padding="buttonPadding"
                :title="buttonLabel"
                color="primary"
                flat
                @click="toggleThemeMode"
            />
        </q-no-ssr>
    </div>
</template>
